import React, { useEffect } from 'react';
import classNames from 'classnames/bind';
import { connect } from 'react-redux';

import { gtmEventPush, segmentEventPush } from '../../../modules/ga/GTMdatalayer';
import styles from './index.pcss';
import {
  getRemovalLoginPasswordJson
} from '../../../refresh/selectors/featureFlagsSelector';

const cx = classNames.bind(styles);

const SuccessVerification = ({ flags }) => {
  useEffect(() => {
    gtmEventPush({
      event: 'pageload',
      page_type: 'restore your mobile number',
      page_name: 'restore your mobile number | verification email'
    });
  }, []);
  const loginRestoreMessageFromFirebase = getRemovalLoginPasswordJson(flags);
  const { verification_email_text = 'Verification Email Sent', verification_email_text_description = '' } = loginRestoreMessageFromFirebase
  return (
    <div className={cx('success-container')}>
      <div className={cx('header')}>{verification_email_text}</div>
      <div className={cx('success-content')}>
        {verification_email_text_description}
      </div>
      <button
        className={cx('success-btn')}
        onClick={() => {
          gtmEventPush({
            event: 'user_account_interactions',
            page_type: 'restore your mobile number',
            page_name: 'restore your mobile number | verification email',
            category: 'user account interactions',
            action: 'restore mobile number',
            label: 'continue shopping'
          });
          // Segment push event
          segmentEventPush({
            event: 'Restore Phone Number Clicked',
            // page_type: 'restore your mobile number',
            screen_name: 'restore your mobile number | verification email',
            category: 'user account interactions',
            action: 'restore mobile number',
            label: 'continue shopping'
          });
          window.location = '/';
        }}
      >
        Continue Shopping
      </button>
    </div>
  );
};
const mapStateToProps = (state, ownProps) => {
  const {
    flags = {}
  } = state;

  return {
    flags
  };
};
export default connect(mapStateToProps, null)(SuccessVerification);;
